import * as React from 'react';

import { Button } from '@coursera/cds-core';
import { color } from '@coursera/coursera-ui';
import { SvgDownload } from '@coursera/coursera-ui/svg';

import MutationResultDetails, { RESULT_TYPES } from 'bundles/enterprise-admin-users/components/MutationResultDetails';
import type CSVInvitationModel from 'bundles/enterprise-admin-users/models/CSVInvitation';
import { OverlayTrigger, Tooltip } from 'bundles/enterprise-ui';

import _t from 'i18n!nls/enterprise-admin-users';

const { INFO, WARNING } = RESULT_TYPES;

const REPORT_ROOT_URL = 'https://www.coursera.org/api/programReportDownloads.v1/?q=file&path=';

type Props = {
  reportPath?: string;
  hasSentInvitations?: boolean;
  csvInvitation?: CSVInvitationModel;
  onDone: () => void;
};

class ImportLearnerResults extends React.Component<Props> {
  getFormattedResults = () => {
    const { csvInvitation, hasSentInvitations } = this.props;
    const invitationCount = csvInvitation && csvInvitation.invitationCount;

    return [
      {
        id: 'success',
        type: INFO,
        label: hasSentInvitations ? _t('Invitations sent') : _t('Learners added'),
        count: invitationCount,
      },
      {
        id: 'skipped',
        type: WARNING,
        label: _t('Rows skipped'),
        count: this.renderSkippedResults(),
      },
    ];
  };

  downloadReport = () => {
    const { reportPath } = this.props;
    window.open(`${REPORT_ROOT_URL}${reportPath}`);
  };

  renderSkippedResults = () => {
    const { csvInvitation, reportPath } = this.props;
    const totalSkippedCount = csvInvitation && csvInvitation.totalSkippedCount;

    const tooltip = <Tooltip>{_t('Download Skipped')}</Tooltip>;

    const overlay = (
      <OverlayTrigger placement="bottom" overlay={tooltip} onClick={this.downloadReport}>
        <SvgDownload size={20} color={color.primary} />
      </OverlayTrigger>
    );

    return (
      <div className="horizontal-box align-items-absolute-center">
        {reportPath && <span className="m-r-1">{overlay}</span>}
        {totalSkippedCount}
      </div>
    );
  };

  render() {
    const { onDone } = this.props;

    return (
      <div className="rc-ImportLearnerResults">
        <h2 className="m-b-3">{_t('Import complete and learners added')}</h2>
        <MutationResultDetails results={this.getFormattedResults()} />
        <div className="horizontal-box align-items-right m-t-3">
          <Button variant="primary" onClick={onDone}>
            {_t('Done')}
          </Button>
        </div>
      </div>
    );
  }
}

export default ImportLearnerResults;
